import { render } from "./Sparkline.vue?vue&type=template&id=21be15af"
import script from "./Sparkline.vue?vue&type=script&lang=js"
export * from "./Sparkline.vue?vue&type=script&lang=js"

import "./Sparkline.vue?vue&type=style&index=0&id=21be15af&lang=css"
script.render = render

export default script